import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponseInfo } from '../http/http.data';
import { XeroAccount } from './xero-account.model';
import { SETTINGS_ROUTE } from '../main/main.data';
import { XERO_INTEGRATION_SETUP_ROUTE } from '../xero/xero.constant';
import { XeroAuthUrl } from './sub-models/xero-auth-url.model';
import { NavigationService } from '../navigation/navigation.service';
import {
  ACCOUNT_STATUS_ROUTE,
  AUTH_URL_ROUTE,
  CALLBACK_URL,
  EXPORT_DOCUMENT,
} from './xero-data.data';
import { SETTINGS_XERO_ROUTE } from '../settings/settings.data';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { map } from 'rxjs/operators';

@Injectable()
export class XeroIntegrationService {
  private _xeroUrl = '/xero';

  constructor(
    private _authHttpService: AuthHttpService,
    private _navigationService: NavigationService
  ) {}

  getAccountStatus(): Observable<XeroAccount> {
    const url = `${this._xeroUrl}/${ACCOUNT_STATUS_ROUTE}`;

    return this._authHttpService
      .get(url)
      .pipe(map(({ body }: IResponseInfo) => new XeroAccount(body)));
  }

  updateAccountStatus(
    autoExport: boolean,
    defaultAccountCode: string,
    country: string,
    i2gCurrency: string
  ): Observable<IResponseInfo> {
    const url = `${this._xeroUrl}/${ACCOUNT_STATUS_ROUTE}`;

    const body = {
      auto_export: autoExport,
      default_account_code: defaultAccountCode,
      country,
      i2g_currency: i2gCurrency,
    };

    return this._authHttpService.put(url, body);
  }

  authorizeAccount(): Observable<XeroAuthUrl> {
    const callbackOrigin: string = this._navigationService.getLocationOrigin();
    const callbackUrl = `${callbackOrigin}/${SETTINGS_ROUTE}/${SETTINGS_XERO_ROUTE}/${XERO_INTEGRATION_SETUP_ROUTE}`;

    const body = {
      [CALLBACK_URL]: callbackUrl,
    };
    const url = `${this._xeroUrl}/${AUTH_URL_ROUTE}`;

    return this._authHttpService
      .post(url, body)
      .pipe(map(({ body }: IResponseInfo) => new XeroAuthUrl(body)));
  }

  deleteXeroAccount(): Observable<IResponseInfo> {
    const url = `${this._xeroUrl}/${ACCOUNT_STATUS_ROUTE}`;

    return this._authHttpService.delete(url);
  }

  exportDocument(documentId: string): Observable<IResponseInfo> {
    const url = `${this._xeroUrl}/${EXPORT_DOCUMENT}/${documentId}`;

    return this._authHttpService.post(
      url,
      {},
      {},
      true,
      'json',
      [400] // xero api always returns 400 for any expected error so we are adding this here to prevent logs in
      // raygun. The appropriaete xero error code is shown to the user in the effects
    );
  }
}
